import React from 'react';

interface AvatarProps {
  user: {
    first_name?: string;
    last_name?: string;
    full_name?: string;
    email?: string;
    picture?: string;
    profile_image_url?: string;
  };
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export default function Avatar({ user, size = 'md', className = '' }: AvatarProps) {
  // Obtener iniciales
  const getInitials = (): string => {
    // Intentar con nombre completo primero
    if (user.full_name) {
      const names = user.full_name.trim().split(' ');
      if (names.length >= 2) {
        return (names[0][0] + names[names.length - 1][0]).toUpperCase();
      }
      if (names.length === 1 && names[0].length >= 2) {
        return names[0].substring(0, 2).toUpperCase();
      }
    }
    
    // Si no, usar first_name y last_name
    if (user.first_name && user.last_name) {
      return (user.first_name[0] + user.last_name[0]).toUpperCase();
    }
    if (user.first_name) {
      return user.first_name.substring(0, 2).toUpperCase();
    }
    
    // Si no hay nombre, usar las primeras 2 letras del email
    if (user.email) {
      return user.email.substring(0, 2).toUpperCase();
    }
    
    return 'U';
  };

  // Tamaños
  const sizeClasses = {
    sm: 'w-8 h-8 text-xs',
    md: 'w-10 h-10 text-sm',
    lg: 'w-12 h-12 text-base'
  };

  const initials = getInitials();

  return (
    <div className={`${sizeClasses[size]} ${className} rounded-full bg-blue-600 text-white flex items-center justify-center font-semibold overflow-hidden`}>
      {(user.picture || user.profile_image_url) ? (
        <img 
          src={user.picture || user.profile_image_url} 
          alt={user.full_name || user.email || 'Usuario'} 
          className="w-full h-full object-cover"
          onError={(e) => {
            // Si falla la imagen, mostrar iniciales
            const target = e.target as HTMLImageElement;
            target.style.display = 'none';
            const parent = target.parentElement;
            if (parent) {
              parent.innerHTML = initials;
            }
          }}
        />
      ) : (
        initials
      )}
    </div>
  );
}

